'use client';

import PDP from 'components/consumer/PDP';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import WarehouseIdHydrator from '@/joystagram-components/global-state/warehouseIdForUser/WarehouseIdHydrator';

const PDPClient = ({
  productOptionsPromise,
  productHeroImagePromise,
  productCylindoHeroImagePromise,
  productBasicDetailsPromise,
  layoutRevampContextPromise,
  slug,
  serverWarehouseId,
  isAdmin,
}) => {
  if (isAdmin) {
    return (
      <AdminPlaceholder>
        ProductAndCategory Component Placeholder for Variant Builder. <br />
        The component will display the product page correctly in Consumer
      </AdminPlaceholder>
    );
  }

  return (
    <WarehouseIdHydrator warehouseId={serverWarehouseId}>
      <PDP
        key={slug}
        productOptionsPromise={productOptionsPromise}
        productHeroImagePromise={productHeroImagePromise}
        productCylindoHeroImagePromise={productCylindoHeroImagePromise}
        productBasicDetailsPromise={productBasicDetailsPromise}
        layoutRevampContextPromise={layoutRevampContextPromise}
      />
    </WarehouseIdHydrator>
  );
};

export default PDPClient;
